import { PageRoute, buildPath, buildTemplatePath } from "@compass/core";

const routeName = "studentQr";

class Params {
    studentId: number = 0;
}

export const studentQrPageRoute: PageRoute<Params> = {
    handle: "Student QR Code",
    templatePath: buildTemplatePath(routeName, Params),
    getPath: (params) => buildPath(routeName, params),
};